
// Shared styling constants for visitor feedback forms
export const INPUT_FIELD_STYLES = "h-11 text-base w-full max-w-xl mx-auto";
export const FORM_CONTAINER_STYLES = "flex flex-col";
export const FORM_CONTENT_STYLES = "w-auto max-w-lg space-y-4";
export const TAB_CONTAINER_STYLES = "w-auto max-w-lg mx-auto";
export const SECTION_SPACING = "space-y-6";
